var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-campaign-targeting-rule',{on:{"save":_vm.save,"close":_vm.close}},[_c('div',{staticClass:"d-flex align-items-center"},[_vm._v("empty content")])])}
var staticRenderFns = []

export { render, staticRenderFns }